$(function(){
  let loading = false;
  
  // 处理submenu__item的鼠标悬浮事件
  function handleSubmenuItemHover($item) {
    if($(".submenu__item.active")[0] != $item[0]){
      $(".submenu__item.active").removeClass("active");
    }
    
    if($(".submenu__item .submenu__item-content.active")[0] != $item.find(".submenu__item-content")[0]) {
      $(".submenu__item  .sub-submenu__item").removeClass("active");
      $(".submenu__item  .submenu__item-content").stop(true, true);
      
      if($(".submenu__item  .submenu__item-content.active")[0]){
        $(".submenu__item  .submenu__item-content.active").stop(true, true).slideUp();
        $(".submenu__item  .submenu__item-content.active").removeClass("active");
        $item.find(".submenu__item-content").addClass("active");  
        $item.find(".submenu__item-content").stop(true, true).slideDown();
      } else {
        $item.find(".submenu__item-content").addClass("active");  
        $item.find(".submenu__item-content").stop(true, true).slideDown();
      }
      
      $("[data-gallery-item-title]").hide();
      let galleryTitle = $item.attr("data-gallery-title");
      $(`[data-gallery-item-title="${galleryTitle}"]`).show();

      let $firstChild = $($item.find(".sub-submenu__item")[0]);
      if($firstChild){
        $firstChild.addClass("active");
        if($firstChild.attr("data-gallery-title")){
          $("[data-gallery-item-title]").hide();
          $(`[data-gallery-item-title="${$firstChild.attr("data-gallery-title")}"]`).show();
        }
      }
    }
  }

  $(".submenu__item").on("mouseenter", function(){
    handleSubmenuItemHover($(this));
  });
  
  $(".sub-submenu__item").on("mouseenter", function(e){
    e.stopPropagation();
    if($(this) != $(".sub-submenu__item.active")){
      $(".sub-submenu__item.active").removeClass("active");
      $(this).addClass("active");
      let galleryTitle = $(this).attr("data-gallery-title");
      
      $("[data-gallery-item-title]").removeClass("active");
      $("[data-gallery-item-title]").hide();
      
      $("[data-gallery-item-title]").addClass("active");
      $(`[data-gallery-item-title="${galleryTitle}"]`).show();
    }
  });

  // 当鼠标悬浮到主菜单时,自动触发第一个submenu__item的hover效果
  $(".t4s-type__mega_v2").on("mouseenter", function() {
    let $firstSubmenuItem = $(this).find(".submenu__wrapper .submenu__item:eq(0)");
    handleSubmenuItemHover($firstSubmenuItem);
  });
  
});